import { useEffect } from 'react';

import { Box, Typography } from '@material-ui/core';
import { Fastfood } from '@material-ui/icons';
import { useIntl } from 'react-intl';

import { useParamsContext } from 'state/params';
import { UseUniversalSearchContext } from 'state/universal-search';

import { useNoDataStyles } from './styles';

const NoData = ({ message }: { message?: string }) => {
  const classes = useNoDataStyles();
  const { params } = useParamsContext();
  const { setFocused } = UseUniversalSearchContext();
  const { formatMessage } = useIntl();
  const defaultGuestMessage = params.guestEmail
    ? formatMessage({ id: 'main.notApplicableForGuestOrders' })
    : undefined;
  const resolvedMessage = message ?? defaultGuestMessage;

  useEffect(() => {
    setFocused(true);
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setFocused(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [setFocused]);

  return (
    <Box sx={{ minWidth: 275 }} className={classes.box}>
      <Fastfood className={classes.placeholderIcon} />
      {!!resolvedMessage && (
        <Typography className={classes.message} variant="body2" color="textSecondary">
          {resolvedMessage}
        </Typography>
      )}
    </Box>
  );
};

export { NoData };
